"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dashboard.search': 'Search groups...',
    'whatsapp.dashboard.filterAll': 'All',
    'whatsapp.dashboard.filterCritical': 'Critical',
    'whatsapp.dashboard.filterWarning': 'Action',
    'whatsapp.dashboard.noGroupSelected': 'Select a group from the left sidebar',
    'whatsapp.dashboard.statsMonitored': 'Monitored groups',
    'whatsapp.dashboard.statsCritical': 'Critical alerts',
    'whatsapp.dashboard.statsMembers': 'Group members',
    'whatsapp.dashboard.statsStatus': 'Groups status',
    'whatsapp.dashboard.messagesConsole': 'Messages',
    'whatsapp.dashboard.activityToday': 'Activity (Today)',
    'whatsapp.dashboard.sentimentGlobal': 'Global sentiment',
    'whatsapp.dashboard.aiStatus.good': 'Good',
    'whatsapp.dashboard.aiStatus.warning': 'Warning',
    'whatsapp.dashboard.aiStatus.critical': 'Critical',
    'whatsapp.dashboard.aiStatus.neutral': 'Neutral',
    'whatsapp.dashboard.selectGroupHint': 'Select a group to preview messages',
    'whatsapp.dashboard.drawer.settings': 'Settings',
    'whatsapp.dashboard.drawer.members': 'Members',
};
